import networkService from '../Network/NetworkManager';
const APPURL = require('../Constants/URLConstants');

const UploadSingleFile = async ({file, full_file}) => {
  try {
    const url = '';

    const response = await networkService.networkCall(
      APPURL.URLPaths.S3signedUploadURL,
      'POST',
      JSON.stringify({files: [file]}),
    );

    if (!response.error) {
      const all_path_response = response.data.result;
      const path = all_path_response[0];

      const res = await fetch(path?.signedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': full_file.type, // Fixed the header name
        },
        body: full_file,
      });

      if (res.status === 200) {
        return path?.fileUri;
      }
    }

    return url;
  } catch (error) {
    return null;
  }
};

export default UploadSingleFile;
